import { UserProvider } from '~/modules/auth/components';
import { Analytics } from '~/modules/monitoring/analytics/Analytics';

import { WmgSessionProvider } from './modules/auth/contexts';
import { Router } from './router';

export function ProtectedApp() {
  return (
    <WmgSessionProvider>
      <UserProvider>
        <Analytics>
          <Router />
        </Analytics>
      </UserProvider>
    </WmgSessionProvider>
  );
}

ProtectedApp.displayName = 'ProtectedApp';
